export class CloseDialogMessage
{
    public handled: boolean = false;
}